import { all, call, put, takeEvery } from 'redux-saga/effects';
import { api } from '../../libs/helpers';
import { trackEvent } from '../analytics/analytics.reducer';
import { getData, getDataSuccess, setAppStore, submitForm } from './app.reducer';

export const submitFormSaga = function* ({ payload }) {
    const { type, bookName, email, userType, bookId, pageUrl } = payload;

    try {
        if (type === 'book') {
            const capture = yield call(api.postBookPdf, { bookId, email, userType, bookName });
            if (capture?.success === false) throw new Error('Capture rejected');
            yield put(
                trackEvent({
                    name: 'workbook_lead_captured',
                    params: {
                        book_name: bookName,
                        book_id: bookId,
                        user_type: userType,
                    },
                })
            );
        } else if (type === 'newsletter') {
            const capture = yield call(api.postNewsletterSignup, { email, pageUrl });
            if (capture?.success === false) throw new Error('Capture rejected');
            yield put(
                trackEvent({
                    name: 'newsletter_signup',
                    params: { page_url: pageUrl || 'unknown' },
                })
            );
        }
    } catch (e) {
        // Capture failed — surface in console; UI already closed.
        console.warn('[submitForm] capture failed');
    }

    yield put(setAppStore({ isSubmitting: false }));
};

const getDataSaga = function* () {
    const dataKeys = ['faqs', 'quotes', 'books', 'blogs'];
    const results = yield all(dataKeys.map((key) => call(api.getS3Data, key)));
    const dataMap = results.reduce((map, group) => {
        map[group.fileName] = group.data;
        return map;
    }, {});
    yield put(getDataSuccess(dataMap));
};

const appSaga = function* () {
    yield takeEvery(setAppStore.type, function* () {});
    yield takeEvery(submitForm.type, submitFormSaga);
    yield takeEvery(getData.type, getDataSaga);
};

export default appSaga;
